!function ($) {

    var defaults = {
		writable: false,
		inintValue: 0,
		minimum: 1,
        maximum: null,
        autohide: true,
		onChange: function(){},
		onMinimize: function(){},
		onMaximize: function(){}
	}

    $.fn.plusMinusCounter = function (options) {
        var $inputCounter,
            $buttonMinus,
			$buttonPlus,
            minimum,
            maximum,
            autohide,
            writable,
            onChange,
            onMinimize,
			onMaximize;

        var $plusMinusCounter = this;
        
        $buttonMinus = $plusMinusCounter.find('.mk-plusminuscounter-btn-minus');
        $inputCounter = $plusMinusCounter.find('input');
        $buttonPlus = $plusMinusCounter.find('.mk-plusminuscounter-btn-plus');

		var settings = $.extend({}, defaults, options);

		inintValue = settings.inintValue;
        minimum = settings.minimum;
        maximum = settings.maximum;
        autohide = settings.autohide;
        writable = settings.writable;
        onChange = settings.onChange;
        onMinimize = settings.onMinimize;
        onMaximize = settings.onMaximize;

		if (!$.isNumeric(minimum)) {
            minimum = defaults.minimum;
        }

		if (!$.isNumeric(maximum)) {
            maximum = defaults.maximum;
		}

        var inputVal = $inputCounter.val();
		if (isNaN(parseInt(inputVal))) {
            inputVal = $inputCounter.val(0).val();
        }

		if (!writable || writable === "false") {
            $inputCounter.prop('disabled', true);
        }

		changeVal(inputVal);

		$inputCounter.val(inputVal);

        $buttonMinus.click(function () {
            var num = parseInt($inputCounter.val());

            if (num > minimum) {
                toggleAriaLive($buttonMinus);
                $inputCounter.val(num - 1);
                changeVal(num - 1);
            }
		});

        function updateMinusAriaLabels() {
            var label = $buttonMinus.attr('data-label');
            var counter = $inputCounter.val();
            var minNumber = minimum.toString();
            var currentNumber = parseInt($inputCounter.val());

            if (currentNumber > minimum) {
                $buttonMinus.attr('aria-label', 'Remove 1 of ' + counter + ' - ' + label);
            }
            else {
                $buttonMinus.attr('aria-label', 'Remove button disabled - the minimum of ' + minNumber + ' indicators for ' + label + ' has been reached');
            }
		}

        $buttonPlus.click(function () {
            var num = parseInt($inputCounter.val());

            if (maximum == null || num < maximum) {
                toggleAriaLive($buttonPlus);
                $inputCounter.val(num + 1);
                changeVal(num + 1);
            }
		});

        function updatePlusAriaLabels() {
            var label = $buttonPlus.attr('data-label');
            var counter = $inputCounter.val();
            var maxNumber = maximum.toString();
            var currentNumber = parseInt($inputCounter.val());
            
            if (currentNumber < maximum) {
                $buttonPlus.attr('aria-label', 'Add 1 to ' + counter + ' - ' + label);
            }
            else {
                $buttonPlus.attr('aria-label', 'Add button disabled - the maximum of ' + maxNumber + ' indicators for ' + label + ' has been reached');
            }
        }

        function toggleAriaLive($e) {
            var parentTag = '.mk-plusminuscounter';

            try {
                $e.parent(parentTag).find('button').attr('aria-live', 'off');
                $e.attr('aria-live', 'polite');
                $e.attr('aria-atomic', 'true');
            }
            catch (err) {
                console.error('function toggleAriaLive error:', err.stack);
            }
        }

		var keyUpTime;

        $inputCounter.keyup(function () {
			clearTimeout(keyUpTime);

            keyUpTime = setTimeout(function() {
                var num = $inputCounter.val();

				if (num == ''){
                    num = minimum;
                    $inputCounter.val(minimum);
                }

				var reg = new RegExp("^[\\d]*$");

				if (isNaN(parseInt(num)) || !reg.test(num)) {
                    $inputCounter.val($inputCounter.data('num'));
                    changeVal($inputCounter.data('num'));
                } 
                else if (num < minimum) {
                    $inputCounter.val(minimum);
                    changeVal(minimum);
                }
                else if (maximum != null && num > maximum) {
                    $inputCounter.val(maximum);
                    changeVal(maximum);
                } 
                else {
                    changeVal(num);
                }
            },300);
		});

        $inputCounter.focus(function () {
            var num = $inputCounter.val();

			if (num == 0) {
				$inputCounter.select();
			}
        })

        $inputCounter.on('input', function() {
            var num = $inputCounter.val();
            changeVal(parseInt(num));
            updateMinusAriaLabels();
            updatePlusAriaLabels();
        });

        function changeVal(num) {
            $inputCounter.data('num', num);
            $buttonMinus.prop('disabled', false);
			$buttonPlus.prop('disabled', false);

            if (num <= minimum) {
                $buttonMinus.prop('disabled', true);
                onMinimize.call(this, num);
            } 
            else if (maximum != null && num >= maximum) {
                $buttonPlus.prop('disabled', true);
                onMaximize.call(this, num);
			}
            
            if (autohide) {
                if (num <= minimum) {
                    $plusMinusCounter.addClass("hidden");
                }
                else {
                    $plusMinusCounter.removeClass("hidden");
                }
            }

            onChange.call(this, num);
        }

        return $plusMinusCounter;
	};

	$.fn.getOwnOptions = function () {
		var own = $(this);

        //  Settings data provided by C#/Razor code (PlusMinusCounterModel.cs & PlusMinusCounter.cshtml)
		return {
            'autohide': (own && own.attr('data-autohide')) ? own.attr('data-autohide') : defaults.autohide,
			'minimum': (own && own.attr('data-min-value')) ? own.attr('data-min-value') : defaults.minimum,
			'maximum': (own && own.attr('data-max-value')) ? own.attr('data-max-value') : defaults.maximum,
			'writable': (own && own.attr('data-writable')) ? own.attr('data-writable') : defaults.writable,
		};
	};

	$(function () {
		$(document).on('loaded', function (event) {
			$(event.target)
				.find('.mk-plusminuscounter')
				.each(function (i, menu) {
					$(menu).plusMinusCounter($(menu).getOwnOptions());
				});
		});
	});

}(window.jQuery);